import { motion } from "framer-motion";
import PreviewBanner from "./PreviewBanner";

// Editorial magazine-cover style: massive framed product, typography wrapping it, monospace stat rails.
export default function HeroEditorial() {
  return (
    <div className="pt-24 pb-24 px-6 md:px-10 min-h-[100svh] relative" data-testid="preview-hero-editorial">
      <PreviewBanner title="Editorial Poster" kind="Hero" />

      {/* left rail */}
      <div className="hidden md:block absolute left-10 top-40 bottom-40 border-l border-[#1A1A1A]" />
      <div className="hidden md:flex flex-col gap-4 absolute left-14 top-40 overline text-[#666]">
        <span>N° 001</span>
        <span>ISSN 2601-0074</span>
        <span>SYD · AU</span>
        <span>SUMMER 2026</span>
      </div>

      {/* right rail */}
      <div className="hidden md:block absolute right-10 top-40 bottom-40 border-r border-[#1A1A1A]" />
      <div className="hidden md:flex flex-col gap-4 absolute right-14 top-40 overline text-[#666] text-right">
        <span>A$ 899 → 3,299</span>
        <span>GrapheneOS 14</span>
        <span>7 Pixels · 3 Tiers</span>
        <span>Hand hardened</span>
      </div>

      <div className="max-w-[1200px] mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="overline mt-4"
        >
          — Volume 01 —
        </motion.div>

        {/* Line 1 */}
        <div className="line-reveal">
          <motion.h1
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1], delay: 0.15 }}
            className="font-display uppercase text-[14vw] md:text-[10vw] leading-[0.85] tracking-[-0.03em] mt-8"
          >
            Silence
          </motion.h1>
        </div>

        {/* Product image slotted between lines */}
        <div className="relative flex items-center justify-center gap-6 md:gap-10 my-2 md:my-6">
          <div className="line-reveal flex-1 text-right">
            <motion.span
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1], delay: 0.3 }}
              className="font-display uppercase text-[14vw] md:text-[10vw] leading-[0.85] tracking-[-0.03em] block"
            >
              is a
            </motion.span>
          </div>
          <motion.div
            initial={{ scale: 0.7, opacity: 0, rotate: -6 }}
            animate={{ scale: 1, opacity: 1, rotate: -6 }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1], delay: 0.6 }}
            className="w-[16vw] md:w-[14vw] aspect-[9/16] relative overflow-hidden border border-[#333] shrink-0"
          >
            <img
              src="https://images.unsplash.com/photo-1724322535079-11b08f7f5c88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxnb29nbGUlMjBwaXhlbCUyMHBob25lJTIwZGFya3xlbnwwfHx8fDE3ODQ1OTE2NTd8MA&ixlib=rb-4.1.0&q=85"
              alt=""
              className="absolute inset-0 w-full h-full object-cover img-clip"
            />
          </motion.div>
          <div className="line-reveal flex-1 text-left">
            <motion.span
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1], delay: 0.45 }}
              className="font-display uppercase text-[14vw] md:text-[10vw] leading-[0.85] tracking-[-0.03em] block"
            >
              feature.
            </motion.span>
          </div>
        </div>

        <div className="line-reveal">
          <motion.h1
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1], delay: 0.6 }}
            className="font-display uppercase text-[14vw] md:text-[10vw] leading-[0.85] tracking-[-0.03em]"
          >
            We <span className="text-[#7C3AED]">ship it.</span>
          </motion.h1>
        </div>

        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.4 }}
          className="max-w-lg mx-auto mt-16 text-[#888] text-sm leading-relaxed"
        >
          A quarterly-edition catalogue of GrapheneOS-powered Pixel devices,
          hand-hardened in Sydney, presented as a document you'd keep on the shelf.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.6 }}
          className="mt-10 flex items-center justify-center gap-6"
        >
          <button className="btn-vault">Open the catalogue</button>
          <button className="btn-ghost">Read Volume 01 →</button>
        </motion.div>
      </div>

      {/* bottom masthead strip */}
      <div className="mt-32 border-t border-[#1A1A1A] pt-6 flex items-center justify-between text-[#666] overline">
        <span>Phantom Phone Quarterly</span>
        <span className="hidden md:inline">Encrypted · No telemetry · Zero knowledge</span>
        <span>Ξ 001</span>
      </div>
    </div>
  );
}
